module.exports = __webpack_public_path__ + "static/media/SIMA.961de60f.png";